import React, { useEffect } from 'react';
import { useGlobal, setGlobal } from 'reactn';
import { Spin } from 'antd';
import Card from '../../common/card/Card';
import Section from '../../common/section/Section';
import Properties from './Properties';
import ProfileInformation from './ProfileInformation';
import NotificationSettings from './NotificationSettings';
import TopBackgroundUrl from '../../assets/MCWA_Dashboard_HeroImage.jpg';
import Moving from '../dashboard/Moving';
import GoPaperless from '../../common/footer/GoPaperless_Footer';
import AutoPay from '../../common/footer/Autopay_Footer';
import { TabList, TabPanel, Tabs, Tab } from 'react-tabs';
import './react-tabs.scss'
import './Tabs.scss';

const Profile = () => {
  const [user] = useGlobal('user');

  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  useEffect(() => {
    setGlobal({
      accountHasEbill: selectedServiceAccount?.eBillStatus?.data?.EBILL_FLAG,
    });
  }, [selectedServiceAccount?.eBillStatus?.data?.EBILL_FLAG]);

  if (!user) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <Spin tip="Loading account information. Please stand by." />
      </div>
    );
  }

  return (
    <div>
      <Section
        title="My Account"
        backgroundImageUrl={TopBackgroundUrl}
        // whiteText
      >
        <div className="flex flex-wrap" style={{ height: '100%' }}>
          <div className="w-full flex flex-wrap" style={{ height: '100%' }}>
            <div className="w-full lg:w-1/3">
              <Properties />
            </div>
            <Card 
              className="p-2 w-full lg:w-2/3"
              TabsComponent={               
                <Tabs >
                  <TabList>
                      <Tab  className='RRT__tab p-8 flex-grow justify-center items-center text-center text-2xl cursor-pointer bg-blue-dark text-white flex flex-column opacity-75'> 
                       Profile Information
                      </Tab>
                      <Tab  className='RRT__tab p-8 flex-grow justify-center items-center text-center text-2xl cursor-pointer bg-blue-dark text-white flex flex-column opacity-75'>
                       Notification Settings
                      </Tab>
                  </TabList>
                    <div className='p-8 '> 
                      <TabPanel>
                          <ProfileInformation customer={user} />
                      </TabPanel>
                      <TabPanel>
                          <NotificationSettings customer={user}  />
                      </TabPanel>
                    </div>                    
                </Tabs>
              }>
            </Card>
          </div>
        </div>
      </Section>
      {serviceAccounts.length > 0 && (
        <Section>
          <div className="w-full flex flex-wrap justify-between">
            <Moving className="w-full lg:w-1/3" />
            <GoPaperless className="w-full lg:w-1/3" />
            <AutoPay className="w-full lg:w-1/3" />
          </div>
        </Section>
      )}
    </div>
  );
};

export default Profile;
